import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Ontology } from '../components/Ontology/Ontology';

export const OntologyLayout = () => (
  <Box display="flex">
    <Box sx={{ pl: '10px', width: '300px' }}>
      <Ontology />
    </Box>
    <Box flexGrow={1}>
      <Outlet />
    </Box>
  </Box>
);
